<template>
  <div class="ui middle center aligned grid" id="account">
    <div class="ui cards">
      <div class="card">
        <div class="content">
          <div class="header">用户信息</div>
          <div class="description">
            <form class="ui form" :class="{error: error, success: success}">
              <div class="field">
                <label>用户账号</label>
                <input type="text" name="username" v-model="account.username" readonly>
              </div>
              <div class="field">
                <label>用户邮箱</label>
                <input type="email" name="email" v-model="account.email" placeholder="邮箱">
              </div>
              <div class="field">
                <label>原始密码</label>
                <input type="password" name="password" v-model="account.oldPassword" placeholder="原始密码">
              </div>
              <div class="field">
                <label>新的密码</label>
                <input type="password" name="password" v-model="account.password" placeholder="新的密码">
              </div>
              <div class="field">
                <label>确认密码</label>
                <input type="password" name="confirm" v-model="account.confirm" placeholder="确认密码">
              </div>
              <div class="ui success message" v-if="success">
                更新成功
              </div>
              <div class="ui error message">
                <p>{{ error }}</p>
              </div>
              <button class="ui primary button" :disabled="success" @click.prevent="submit">更新</button>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'AccountInfo',
  data () {
    return {
      error: '',
      success: false,
      account: {
        email: '',
        username: '',
        oldPassword: '',
        password: '',
        confirm: ''
      },
    }
  },
  mounted () {
    this.load()
  },
  methods: {
    load() {
      axios.get('/users/info').then(({data}) => {
        this.account.username = data.username
        this.account.email = data.email
      })
    },
    submit() {
      this.error = ''
      if (this.account.password) {
        if (this.account.password.length < 8) {
          this.error = '密码长度至少8位'
          return
        }
        if (this.account.password !== this.account.confirm) {
          this.error = '密码不匹配'
          return
        }
      }

      const account = {
        email: this.account.email,
        password: this.account.password,
        oldPassword: this.account.oldPassword,
      }
      axios.post('/users/info', account).then(() => {
        this.success = true
        this.account.password = ''
        this.account.oldPassword = ''
        this.account.confirm = ''
        this.$toasted.success('更新成功')
        setTimeout(() => this.success = false, 2000)
      }, (error) => {
        this.error = error.message
      })
    }
  }
}
</script>

<style scoped>
#account {
  margin-top: 100px;
}
</style>
